module.exports = __webpack_public_path__ + "img/icono-link.3b7ca9a0.svg";